import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import AlertInfoIcon from '@/assets/icons/alert-info-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

export const NoAnalyticsDataInfo = () => {
    const translate = useTranslate();
    return (
        <Box
            className='no-analytics-data-info'
            sx={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'transparent',
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: Palette.blue.blue50,
                        padding: '16px',
                        borderRadius: '16px',
                        gap: '12px',
                    }}
                >
                    <Box sx={{ flexShrink: 0, width: '24px', height: '24px' }}>
                        <AlertInfoIcon />
                    </Box>
                    <Typography
                        variant='caption'
                        sx={{
                            maxWidth: '208px',
                            fontSize: '14px',
                        }}
                    >
                        {translate('common.noData')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
